export const domain = import.meta.env.VITE_APP_DOMAIN;
export const consumer_app_client_id = import.meta.env
  .VITE_APP_CONSUMER_CLIENT_ID;
export const loan_officer_app_client_id = import.meta.env
  .VITE_APP_LOAN_OFFICER_CLIENT_ID;
export const chat_end_point = import.meta.env.VITE_APP_CHAT_END_POINT;

const resolveApiBase = () => {
  const envBase = import.meta.env.VITE_APP_BASE_URI;
  if (envBase) {
    return envBase;
  }

  if (typeof window === 'undefined') {
    return '';
  }

  const hostname = window.location.hostname || 'localhost';
  const protocol = window.location.protocol || 'http:';
  return `${protocol}//${hostname}:8001/api/v1`;
};

const apiBase = resolveApiBase().replace(/\/$/, '');
// export const loan_service_api = 'http://127.0.0.1:5001/';
export const loan_service_api = `${apiBase}/loan`;
export const api = apiBase;
export const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
export const sentry_dsn = import.meta.env.VITE_SENTRY_DSN;

export const company_logo = import.meta.env.VITE_COMPANY_LOGO || '/Logo.png';

export const roles = {
  loanOfficer: 'loanOfficer',
  consumer: 'consumer',
  organization: 'organization',
  superAdmin: 'superAdmin',
  branchAdmin: 'branchAdmin',
  loanProcessor: 'loanProcessor',
};
